// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3BhmH","checkboxWrapper":"styles_checkboxWrapper__2vQ_R"};